import {PaymentError} from '../error-handling/payment-error.enum';
import {DelegoRapidPayAuthorization} from '@app/model/delego-rapidpay/delego-rapidpay-authorization';
import {DelegoRapidPayThreeDSecureInfoWithDelegoToken} from '@app/model/delego-rapidpay/delego-rapidpay-authenticate';
import {PlaceOrderRequestBody} from '@app/model/order/dcp-place-order-body.model';
import {HttpErrorResponse} from '@angular/common/http';
import {PayerAuthEnrollmentResponse} from '@app/model/cyber-source/payer-auth-enrollment-response';

export const PAYMENT_AUTHORIZATION_FEATURE = 'payment-authorization';

/**
 * T is data type, E is error type
 */
export interface PaymentState<T = any, E = any> {
  loading?: boolean;
  error?: false | E;
  data?: T | undefined;
}

export interface DelegoPaymentState extends PaymentState<DelegoAuthorizationResults, PaymentError> {
  cartId?: string;
  cardType?: string;
  start?: boolean;
  consignmentCodes?: string[];
}

export interface StripePaymentState extends PaymentState<PlaceOrderRequestBody, HttpErrorResponse> {
  cartId?: string;
  isPaymentIntentRequired?: boolean;
}

export interface CyberSourcePaymentState extends PaymentState<PlaceOrderRequestBody, any> {
  authEnrollmentResponse?: PayerAuthEnrollmentResponse;
}

export interface DelegoAuthorizationResults {
  [code: string]: AuthorizationResult;
}

export interface AuthorizationResult {
  code: string;
  merchantId?: string;
  delegoAuthenticationResponse?: DelegoRapidPayThreeDSecureInfoWithDelegoToken;
  delegoAuthorizationResponse?: DelegoRapidPayAuthorization;
  authenticationNotRequired?: boolean;
}

export const delegoInitialState: DelegoPaymentState = {
  start: false,
  loading: false,
  data: undefined,
  error: false,
  cardType: undefined,
  consignmentCodes: [],
};

export const stripeInitialState: StripePaymentState = {
  loading: false,
  isPaymentIntentRequired: false,
  data: undefined,
  error: false,
};

export const cyberSourceInitialState: CyberSourcePaymentState = {
  data: undefined,
  error: false,
};
